document.addEventListener('DOMContentLoaded', () => {
   /** init gtm after 3500 ms */
   setTimeout(initGTM, 3500);
});

document.addEventListener('scroll', initGTMOnEvent);
document.addEventListener('mousemove', initGTMOnEvent);
document.addEventListener('touchstart', initGTMOnEvent);

function initGTMOnEvent(event) {
    initGTM();
    event.currentTarget.removeEventListener(event.type, initGTMOnEvent);
}

function initGTM() {
    if (window.gtmDidInit) {
        return;
    }

    window.gtmDidInit = true; // flag to ensure script does not get added multiple times

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;

    // Ensure PageViews is always tracked (on script load)
    script.onload = () => {
        dataLayer.push({ event: 'gtm.js', 'gtm-start': new Date().getTime(), 'gtm.uniqueEventId': 0 });
    }
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KCQHXGM';

    document.head.appendChild(script);
}